import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";

// Fireside제품탭 파악
export const useIsFiresideProduct = () => {
  const [productKey] = useRecoilState(productKeyAtom);

  return { isFiresideProduct: productKey === "FIRESIDE" };
};
